import React from 'react'
import { platformLinkToString } from '@app/components/ui/buttons/PlatformLink'

export const PlatformDescription = ({ linkProps, ...props }) => {
  let params = {}

  if (window.COUNTRY === 'IN') {
    params = Object.assign(params, {
      utm_source: 'bricsmath',
      utm_medium: 'link',
      utm_campaign: 'eternal_link',
      utm_content: 'signup_link'
    })
  }

  const platform = () => {
    return {
      __html: I18n.t('auth.platform_info', {
        platform: platformLinkToString({ ...Object.assign(linkProps, { params: params }), sso: true })
      })
    }
  }

  return ( <p {...props} dangerouslySetInnerHTML={ platform() } /> )
}

